// extracted by mini-css-extract-plugin
export default {"pageName":"Blog_pageName__BOIPR","pageTitleWrapper":"Blog_pageTitleWrapper__3M+pt","carts":"Blog_carts__BQ3mp"};